import {
  Breadcrumbs,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { ReactComponent as EmptyCamera } from "assets/Svgs/EmptyCamera.svg";
import EquipmentPhotoWrapper from "assets/Svgs/no-machine.jpg";
import { ReactComponent as FileUpload } from "assets/Svgs/FileUpload.svg";
import { ReactComponent as MesuSVG } from "assets/Svgs/MesuTabletSvg.svg";
import clsx from "clsx";
import ScopeHeader from "components/ScopeHeader";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

import CreatableSelect from "react-select";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

import { ReactComponent as NewDelete } from "assets/Svgs/BackupDelete.svg";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Document,
  Image,
  PDFDownloadLink,
  Page,
  StyleSheet,
  Svg,
  Text,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import QRRCode from "react-qr-code";

import { Box } from "@mui/system";
import DeletePopUp from "components/DeletePopup";
import i18n from "i18n/i18n";
import {
  getFileExtention,
  images_enum,
  truncateWithEllipses,
} from "utils/helper";
import { useBoundStore } from "store/store";
import axios from "axios";
import { base_url, config_url } from "../../constants";
import Logo from "assets/Svgs/logo.png";
import QRCode from "qrcode";

function CreateEquipment() {
  const location = useLocation();

  const [loader, setLoader] = useState(false); // on saving equipment

  const isAuthUser = useBoundStore((state) => state.isAuthUser);
  const lang: any = useBoundStore((state) => state.lang);

  const legalEntityNodeId = useBoundStore((state) => state.legalEntityNodeId);

  const brandTypes: any = useBoundStore((state) => state.brandTypes);

  const processsGetlebrty: any = useBoundStore(
    (state) => state.processsGetlebrty,
  );

  const loadTopology: any = useBoundStore((state) => state.loadTopology);
  const createEqConfig: any = useBoundStore((state) => state.createEqConfig);
  const updateEquipment: any = useBoundStore((state) => state.updateEquipment);

  let defaultAreaNodeId = "";
  let defaultSiteId = "";
  let defaultEquipmentId = "";

  const [land, setLand] = useState("");

  const [area, setArea] = useState(defaultAreaNodeId);
  const [site, setSite] = useState(defaultSiteId);

  const [uploadurl, setuploadurl] = useState("");

  const [isIdentical, setIsIdentical] = useState("");

  const [equipmentPhoto, setEquipmentPhoto] = useState("");

  const [typenschildPhoto, setTypenschildPhoto] = useState("");

  const [typenschildPhotoObj, setTypenschildPhotoObj] = useState<any>("");
  const [equipmentPhotoObj, setEquipmentPhotoObj] = useState<any>();

  const [nodeid, setnodeid] = useState("");

  const [internerName, setInternerName] = useState("");

  const [equipmentId, setEquipmentId] = useState("");

  const [inventoryId, setInventoryId] = useState("");

  const [constructionDate, setConstructionDate] = useState("");

  const [manufacturerSerialNumber, setManufacturerSerialNumber] = useState("");

  const [openDialogDelete, setopenDialogDelete] = useState(false);

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const [equipmenttypenodeid, setequipmenttypenodeid] = useState("");

  const [brand, setbrand] = useState<any>(null);

  const [mimeTypeNP, setMimeTypeNP] = useState();
  const [fileIdNP, setFileIdNP] = useState();

  const [fileId, setFileId] = useState();

  const [fileid, setfileid] = useState("");

  const [uploadUrlNP, setUploadUrlNP] = useState();
  const [childImageNP, setChildImageNP] = useState();
  const [bucketIdNP, setbucketIdNP] = useState();
  const [attachmentNodeidNP, setAttachmentNodeidNP] = useState();
  const [attachmentNodeid, setattachmentNodeid] = useState();

  const [fileVersionNP, setFileVersionNP] = useState();

  const [eqPool, setEqPool] = useState("");

  const [mimetype, setmimetype] = useState("");

  const [bucketid, setbucketid] = useState("");
  const [fileVersion, setFileVersion] = useState("");

  const [types, settypes] = useState("");

  const [model, setmodel] = useState(null);

  const [selectedDate, setSelectedDate] = useState("");

  const [typePreviewModel, setTypePreviewModel] = useState(false);

  const [formError, setFormError] = useState([]);

  const [targetLegalEntity, setTargetLegalEntity] = useState(null);

  const [locationEquipment, setLocationEquipment] = useState(null);

  const [editMode, setEditMode] = useState(false);

  interface SiteData {
    [siteId: string]: {
      name: string;
      nodeid: string;
      hasarea: Array<{ area: Record<string, any> }>;
    };
  }

  const siteData: SiteData = useBoundStore((state) => state.subscribedSites);

  useEffect(() => {
    let errorArray = [];
    if (brand === null || Object.keys(brand).length === 0) {
      errorArray.push("brandError");
    }
  }, [brand]);

  useEffect(() => {
    processsGetlebrty();
    if (location?.state?.pageType == "add") {
      let area = location.state.areanodeid + "$" + location.state.areaname;
      let site = location.state.sitenodeid + "$" + location.state.sitename;

      setnodeid(uuidv4());
      setArea(area);
      setSite(site);
    } else if (location?.state?.pageType == "edit") {
      setEditMode(true);
      let eq = location.state?.equipment?.equipment;
      if (eq) {
        setnodeid(eq?.nodeid);
        setInternerName(eq.name);
        setEquipmentId(eq.equipmentid);
        setInventoryId(eq.inventoryid);
        setManufacturerSerialNumber(eq.manufacturerserialnumber);
        setSelectedDate(eq.constructiondate);
        setConstructionDate(eq.constructiondate);

        if (eq.image && Object.keys(eq.image).length) {
          setEquipmentPhoto(eq.image.url);
          setfileid(eq.image.fileid);
          setmimetype(eq.image.mimetype);
          setbucketid(eq.image.bucketid);
          setFileVersion(eq.image.fileversion);
        }

        if (eq.typenameplate && Object.keys(eq.typenameplate).length) {
          setTypenschildPhoto(eq?.typenameplate?.url);
          setFileIdNP(eq.typenameplate.fileid);
          setMimeTypeNP(eq.typenameplate.mimetype);
          setbucketIdNP(eq.typenameplate.bucketid);
          setFileVersionNP(eq.typenameplate.fileversion);
        }
      }
    }
  }, []);

  const name = internerName;

  const handleCloseTypePreviewModel = () => {
    setTypePreviewModel(false);
  };

  const handleTypeInputClick = (e: any) => {
    e.stopPropagation();
  };

  const handleLabelClick = () => {
    if (typenschildPhoto !== "") {
      setTypePreviewModel(true);
    }
  };

  const receiveChildValue = (value: any) => {
    const fileid = value[0];
    const uploadurl = value[1];
    const child_image = value[2];

    setmimetype(child_image.type);
    setfileid(fileid);
    setuploadurl(uploadurl);
    setEquipmentPhotoObj(child_image);
    setbucketid(value[3]);
    setattachmentNodeid(value[4]);
    setFileVersion(value[5]);
  };

  const receiveChildValueTypeNamePlate = (value: any) => {
    const fileid = value[0];
    const uploadurl = value[1];
    const child_image = value[2];

    setMimeTypeNP(child_image.type);
    setFileIdNP(fileid);
    setUploadUrlNP(uploadurl);
    setTypenschildPhotoObj(child_image);
    setbucketIdNP(value[3]);
    setAttachmentNodeidNP(value[4]);
    setFileVersionNP(value[5]);
  };

  const handleNewImageMP = (e: any) => {
    e.preventDefault();
    var image = e.target.files[0];

    const exstention = getFileExtention(image?.type);
    if (e.target.files.length > 0) {
      const file = URL.createObjectURL(e.target.files[0]);
      setEquipmentPhoto(file);
      setEquipmentPhotoObj(image);

      const user_token: any = sessionStorage.getItem("accessToken");
      const url = base_url + "api/v1/files";

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user_token,
        },
      };

      const exstension_payload = [];

      if (location?.state?.pageType == "edit") {
        exstension_payload.push({
          nodeid: nodeid,
          extension: exstention,
          fileid: fileId,
        });
      } else {
        exstension_payload.push({
          nodeid: config_url + nodeid,
          extension: exstention,
        });
      }

      const response = axios
        .post(
          url,
          {
            count: 1,
            extensions: exstension_payload,
          },
          config,
        )
        .then((res) => {
          var arr = [];
          const fileid = res.data[0].fileid;
          const uploadurl = res.data[0].url;
          const bucketid = res.data[0].bucketid;
          arr.push(fileid);
          arr.push(uploadurl);
          arr.push(image);
          arr.push(bucketid);
          arr.push(nodeid);
          arr.push(res.data[0].fileversion);
          receiveChildValue(arr);
          return res;
        })
        .catch(function (error) {});
      return response;
    }
  };

  const handleNewImageNP = (e: any) => {
    e.preventDefault();
    var image = e.target.files[0];
    const exstention = getFileExtention(image?.type);
    if (e.target.files.length > 0) {
      const file = URL.createObjectURL(e.target.files[0]);
      setTypenschildPhoto(file);
      setTypenschildPhotoObj(image);

      const user_token: any = sessionStorage.getItem("accessToken");
      const url = base_url + "api/v1/files";

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user_token,
        },
      };

      const exstension_payload = [];
      if (location?.state?.pageType == "edit") {
        exstension_payload.push({
          nodeid: nodeid,
          extension: exstention,
          fileid: fileIdNP,
        });
      } else {
        exstension_payload.push({
          nodeid: config_url + nodeid,
          extension: exstention,
        });
      }

      const response = axios
        .post(
          url,
          {
            count: 1,
            extensions: exstension_payload,
          },
          config,
        )
        .then((res) => {
          var arr = [];
          const fileid = res.data[0].fileid;
          const uploadurl = res.data[0].url;
          const bucketid = res.data[0].bucketid;
          arr.push(fileid);
          arr.push(uploadurl);
          arr.push(image);
          arr.push(bucketid);
          arr.push(nodeid);
          arr.push(res.data[0].fileversion);
          receiveChildValueTypeNamePlate(arr);
          return res;
        })
        .catch(function (error) {});
      return response;
    }
  };

  const handleDeleteTypenschild = () => {
    setTypenschildPhoto("");
    setTypenschildPhotoObj("");
  };

  const navigate = useNavigate();

  const handleAddMachine = async () => {
    setLoader(true);
    // upload files to minio

    let image;
    let typenameplate;
    if (equipmentPhoto != "") {
      let url = uploadurl;
      const config = {
        headers: {
          "Content-Type": equipmentPhotoObj.type,
          "Access-Control-Allow-Origin": "*",
        },
      };

      const response = await axios
        .put(url, equipmentPhotoObj, config)
        .then((res) => {})
        .catch(function (error) {});

      image = {
        fileid: fileid,
        mimetype: mimetype,
        bucketid: bucketid,
        fileversion: fileVersion,
      };
    }

    if (typenschildPhotoObj != "") {
      const configNP = {
        headers: {
          "Content-Type": typenschildPhotoObj.type,
          "Access-Control-Allow-Origin": "*",
        },
      };
      let url: any = uploadUrlNP;
      const response101 = await axios
        .put(url, typenschildPhotoObj, configNP)
        .then((res) => {})
        .catch(function (error) {
          setLoader(false);
        });

      typenameplate = {
        fileid: fileIdNP,
        mimetype: mimeTypeNP,
        bucketid: bucketIdNP,
        fileversion: fileVersionNP,
      };
    }

    const addPayload = {
      isattachmentof: config_url + nodeid,
      lang: lang,
      name: internerName,
      equipmentid: equipmentId,
      inventoryid: inventoryId,
      constructiondate: constructionDate,
      manufacturerserialnumber: manufacturerSerialNumber,
      isequipmentof: [area.split("$")[0]],
      equipmenttypenodeid: brand.value,
      image: image,
      typenameplate: typenameplate,
      equipmentnodeid: config_url + nodeid,
      legalentitynodeid: legalEntityNodeId,
    };

    const promises = await createEqConfig(addPayload);
    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
        setLoader(false);
        navigate("/sites?sitenodeid=" + site.split("$")[0]);
        await loadTopology(lang);
      } catch (error) {
        setLoader(false);
        console.error("Error during promise execution:", error);
      }
    }
  };

  const handleEditMachine = async () => {
    // upload files to minio

    setLoader(true);

    let image;
    let typenameplate: any = {};
    if (equipmentPhotoObj != undefined) {
      let url = uploadurl;
      const config = {
        headers: {
          "Content-Type": equipmentPhotoObj.type,
          "Access-Control-Allow-Origin": "*",
        },
      };

      const response = await axios
        .put(url, equipmentPhotoObj, config)
        .then((res) => {})
        .catch(function (error) {
          setLoader(false);
        });

      image = {
        fileid: fileid,
        mimetype: mimetype,
        bucketid: bucketid,
        fileversion: fileVersion,
      };
    }

    if (typenschildPhotoObj != "") {
      const configNP = {
        headers: {
          "Content-Type": typenschildPhotoObj.type,
          "Access-Control-Allow-Origin": "*",
        },
      };
      let url: any = uploadUrlNP;
      const response101 = await axios
        .put(url, typenschildPhotoObj, configNP)
        .then((res) => {})
        .catch(function (error) {
          setLoader(false);
        });

      typenameplate = {
        fileid: fileIdNP,
        mimetype: mimeTypeNP,
        bucketid: bucketIdNP,
        fileversion: fileVersionNP,
      };
    }

    const editPayload = {
      lang: lang,
      name: internerName,
      equipmentid: equipmentId,
      inventoryid: inventoryId,
      constructiondate: constructionDate,
      manufacturerserialnumber: manufacturerSerialNumber,
      image: image,
      typenameplate: typenameplate,
      equipmentnodeid: nodeid,
      nodeid: nodeid,
      legalentitynodeid: legalEntityNodeId,
    };

    const promises = await updateEquipment(editPayload);
    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);
        setLoader(false);
        if (location.state.from === "sitePage") {
          navigate(
            "/sites?sitenodeid=" +
              location.state.equipment.equipment.isequipmentof[0].area
                .isareaof[0].site.nodeid,
          );
        } else {
          navigate(
            "/machine-detail?nodeid=" +
              location.state.equipment.equipment.nodeid +
              "&tab=0",
          );
        }
        await loadTopology(lang);
      } catch (error) {
        setLoader(false);
        console.error("Error during promise execution:", error);
      }
    }
  };

  const handleDateChange = (date: any) => {
    const ts: any = dayjs(date).unix() * 1000;
    setConstructionDate(ts);
  };

  const styless = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      paddingLeft: 10,
    },
    image: {
      marginVertical: 10,
      marginHorizontal: 220,
      width: 100,
    },
    qrCode: {
      height: 300,
      width: 300,
      marginHorizontal: 120,
      marginVertical: 5,
    },
  });

  const MyDoc = () => (
    <Document>
      <Page>
        <Image style={styless.image} src={Logo} />
        <Image src={generateQR(nodeid)} style={styless.qrCode} />

        <Text style={styless.subtitle}> {internerName}</Text>

        <Text style={styless.subtitle}>{brand?.label}</Text>
      </Page>
    </Document>
  );

  const generateQR = async (text: any) => {
    try {
      return await QRCode.toDataURL(text);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Dialog onClose={handleCloseTypePreviewModel} open={typePreviewModel}>
        <DialogContent>
          <img src={typenschildPhoto} className="typSchildModelImg" />
          <div className="typSchildModelButton">
            <Button
              variant="contained"
              onClick={() => {
                setTypePreviewModel(false);
              }}
            >
              X
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Breadcrumbs aria-label="breadcrumb">
        <div
          onClick={() => {
            navigate(-1);
          }}
          style={{
            color: "rgba(0, 0, 0, 0.38)",
            display: "flex",
            cursor: "pointer",
            margin: "15px 0px",
          }}
        >
          <ArrowBackIcon />
          {i18n(lang).backLink}
        </div>
      </Breadcrumbs>

      <ScopeHeader
        bgColor="#B21412"
        bgImage="images/scope_header.png"
        txtColor="#FFFFFF"
        title={i18n(lang).equipment}
        description={i18n(lang).equipment_scope_description}
      />

      <Paper sx={{ marginBottom: "48px", padding: "22px" }}>
        <div
          className={clsx("createEquipment")}
          style={{
            marginBottom: "10px",
            paddingBottom: editMode ? "0px" : "24px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {editMode ? (
              <div className="_title">
                {location?.state?.equipment?.equipment?.hasequipmenttype &&
                  location?.state?.equipment?.equipment?.hasequipmenttype[0]
                    ?.equipmenttype.isequipmenttypeof[0]?.brand?.name +
                    " " +
                    location?.state?.equipment?.equipment?.hasequipmenttype &&
                  location?.state?.equipment?.equipment?.hasequipmenttype[0]
                    .equipmenttype.model}
              </div>
            ) : (
              <div className="_title">{i18n(lang).create_equipment_title}</div>
            )}
          </div>

          {editMode ? (
            ""
          ) : (
            <>
              <Grid container spacing={4} sx={{ marginTop: "0px" }}>
                <Grid item xs={4.8}>
                  <FormControl fullWidth>
                    <CreatableSelect
                      isLoading={false}
                      value={brand}
                      defaultValue={null}
                      menuPosition="absolute"
                      className="typesSelect"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          height: "56px",
                          zIndex: 9999,
                          border:
                            brand === "" || brand === null
                              ? "1px solid red"
                              : "",
                        }),
                      }}
                      onChange={(e: any) => {
                        setbrand(e);
                      }}
                      placeholder={i18n(lang).type}
                      isClearable
                      options={
                        brandTypes[0]
                          ? brandTypes[0]?.legalentity?.hasbrand[0]?.brand?.hasequipmenttype.map(
                              (type: any) => {
                                return {
                                  label: type.equipmenttype.model,
                                  value: type.equipmenttype.nodeid,
                                };
                              },
                            )
                          : []
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Divider
                orientation="horizontal"
                sx={{ margin: "15px 0px 0px 0px" }}
              />
            </>
          )}
        </div>

        <div className="_fileUploadContainer">
          <div
            className={clsx("createEquipment")}
            style={{ margin: "0px", paddingTop: "0px" }}
          >
            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={11.5}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label={i18n(lang).internername}
                  value={internerName}
                  onChange={(e) => {
                    setInternerName(e.target.value);
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={5.8}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label={i18n(lang).eq_id}
                  value={equipmentId}
                  onChange={(e) => {
                    setEquipmentId(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={5.7}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label={i18n(lang).inv_id}
                  value={inventoryId}
                  onChange={(e) => {
                    setInventoryId(e.target.value);
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={11.5}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={i18n(lang).built_year}
                      onChange={handleDateChange}
                      value={dayjs(selectedDate)}
                      views={["year"]}
                      disableFuture
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={4} sx={{ marginTop: "0px" }}>
              <Grid item xs={5.8}>
                <TextField
                  fullWidth
                  id="outlined-helperText"
                  label={i18n(lang).manufacturer_serial_number}
                  value={manufacturerSerialNumber}
                  onChange={(e) => {
                    setManufacturerSerialNumber(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={5.8}>
                <Card variant="outlined" onClick={handleTypeInputClick}>
                  {typenschildPhoto === "" && (
                    <input
                      id="myInput"
                      style={{ display: "none" }}
                      type="file"
                      accept={images_enum}
                      onChange={handleNewImageNP}
                    />
                  )}
                  <CardActionArea
                    style={{ display: "flex", justifyContent: "start" }}
                  >
                    <label
                      htmlFor="myInput"
                      style={{ display: "flex", alignItems: "center" }}
                      onClick={handleLabelClick}
                      className="createEqLabel"
                    >
                      <CardHeader
                        className="NT_cardHeader"
                        avatar={
                          <Icon color="primary">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_3115_10382"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_3115_10382)">
                                <path
                                  d="M11 18.5C12.25 18.5 13.3127 18.0627 14.188 17.188C15.0627 16.3127 15.5 15.25 15.5 14C15.5 12.75 15.0627 11.6873 14.188 10.812C13.3127 9.93733 12.25 9.5 11 9.5C9.75 9.5 8.68733 9.93733 7.812 10.812C6.93733 11.6873 6.5 12.75 6.5 14C6.5 15.25 6.93733 16.3127 7.812 17.188C8.68733 18.0627 9.75 18.5 11 18.5ZM3 22C2.45 22 1.97933 21.8043 1.588 21.413C1.196 21.021 1 20.55 1 20V8C1 7.45 1.196 6.97933 1.588 6.588C1.97933 6.196 2.45 6 3 6H6.15L7.4 4.65C7.58333 4.45 7.804 4.29167 8.062 4.175C8.32067 4.05833 8.59167 4 8.875 4H13C13.2833 4 13.521 4.09567 13.713 4.287C13.9043 4.479 14 4.71667 14 5V8H3V20H19V11H20C20.1333 11 20.2627 11.025 20.388 11.075C20.5127 11.125 20.621 11.1957 20.713 11.287C20.8043 11.379 20.875 11.4873 20.925 11.612C20.975 11.7373 21 11.8667 21 12V20C21 20.55 20.8043 21.021 20.413 21.413C20.021 21.8043 19.55 22 19 22H3ZM19 6H18C17.7167 6 17.4793 5.90433 17.288 5.713C17.096 5.521 17 5.28333 17 5C17 4.71667 17.096 4.479 17.288 4.287C17.4793 4.09567 17.7167 4 18 4H19V3C19 2.71667 19.096 2.479 19.288 2.287C19.4793 2.09567 19.7167 2 20 2C20.2833 2 20.5207 2.09567 20.712 2.287C20.904 2.479 21 2.71667 21 3V4H22C22.2833 4 22.5207 4.09567 22.712 4.287C22.904 4.479 23 4.71667 23 5C23 5.28333 22.904 5.521 22.712 5.713C22.5207 5.90433 22.2833 6 22 6H21V7C21 7.28333 20.904 7.521 20.712 7.713C20.5207 7.90433 20.2833 8 20 8C19.7167 8 19.4793 7.90433 19.288 7.713C19.096 7.521 19 7.28333 19 7V6Z"
                                  fill="black"
                                  fillOpacity="0.5"
                                />
                              </g>
                            </svg>
                          </Icon>
                        }
                        title={i18n(lang).add_nameplate_photo}
                      />
                    </label>
                    {typenschildPhoto && (
                      <div onClick={handleDeleteTypenschild}>
                        {" "}
                        <NewDelete />
                      </div>
                    )}
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </div>
          <div className="cameraImageUploadWrapper">
            {equipmentPhoto?.length ? (
              <img
                className="bxShadow"
                src={equipmentPhoto}
                width={100}
                height={100}
                style={{ borderRadius: "50%", objectFit: "contain" }}
              />
            ) : (
              <EmptyCamera />
            )}
            <input
              id="myInput1"
              style={{ display: "none" }}
              type="file"
              accept={images_enum}
              onChange={handleNewImageMP}
            />
            <label htmlFor="myInput1">
              <FileUpload className="fileUploadSvg" />
            </label>
          </div>
        </div>

        <Divider orientation="horizontal" sx={{ margin: "20px 0px" }} />

        {editMode ? (
          ""
        ) : (
          <>
            <div
              className={clsx("createEquipment")}
              style={{ paddingTop: "0px", marginBottom: 0 }}
            >
              <div className="_title">{i18n(lang).assign_equipment}</div>
            </div>

            <div className="createEquipment">
              <Grid container spacing={4} sx={{ marginTop: "0px" }}>
                <Grid item xs={5} paddingTop={0}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      {i18n(lang).single_site}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={site}
                      label={i18n(lang).single_site}
                      onChange={(e) => {
                        setSite(e.target.value);
                        setArea("");
                      }}
                    >
                      {siteData &&
                        Object.keys(siteData).map(
                          (st: any, index) =>
                            siteData[st]?.hasarea && (
                              <MenuItem
                                value={
                                  siteData[st].nodeid + "$" + siteData[st].name // nodeid + "$" splitter + name
                                }
                              >
                                {"" + siteData[st].name}
                              </MenuItem>
                            ),
                        )}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={4.8} marginTop={0} marginLeft={0}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      {i18n(lang).single_area}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={area}
                      label={i18n(lang).single_area}
                      onChange={(e) => {
                        setArea(e.target.value);
                      }}
                      error={area === ""}
                    >
                      {siteData &&
                        Object.keys(siteData).map(
                          (st: any, index) =>
                            siteData[st].nodeid === site?.split("$")[0] &&
                            siteData[st].hasarea &&
                            siteData[st].hasarea.map((area: any) => {
                              return (
                                <MenuItem
                                  value={
                                    area.area.nodeid + "$" + area.area.name
                                  }
                                >
                                  {area.area.name}
                                </MenuItem>
                              );
                            }),
                        )}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>

            <br></br>
            <Divider orientation="horizontal" />
          </>
        )}

        <div className="stickerWrapper">
          <div style={{ width: "50%" }}>
            <div className="_title">{i18n(lang).eq_preview}</div>
            <div className="equipmentPlateDiv bxShadow">
              <div className="photoWrapper">
                {equipmentPhoto === "" || equipmentPhoto === undefined ? (
                  <img
                    src={EquipmentPhotoWrapper}
                    style={{ objectFit: "cover" }}
                  />
                ) : (
                  <img src={equipmentPhoto} />
                )}
              </div>
              <div className="_contentWrapper">
                <div className="_border"></div>

                <div className="_content">
                  <Tooltip title={internerName}>
                    <div className="eqName1 truncate">
                      {truncateWithEllipses(internerName, 40)}
                    </div>
                  </Tooltip>

                  <div className="eqName2">
                    {editMode
                      ? location.state.equipment?.equipment?.isequipmentof[0]
                          .area.isareaof[0].site.name
                      : site?.split("$")[1]}
                  </div>
                  <div className="eqSiteName">
                    {editMode
                      ? location.state.equipment?.equipment?.isequipmentof[0]
                          .area.name
                      : area?.split("$")[1]}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ paddingLeft: "4%", width: "50%" }}>
            <div className="_title">{i18n(lang).service_sticker}</div>
            <div className="equipmentPlateDiv bxShadow">
              <div className="qrCodeWrapper">
                <QRRCode
                  style={{ height: "100%", maxWidth: "100%", width: "100%" }}
                  value={location?.state?.pageType === "add" ? "ok" : ""}
                  viewBox={`0 0 256 256`}
                />
              </div>
              <div className="_contentWrapper">
                <div className="_content">
                  <div className="eqName1">
                    <MesuSVG />
                  </div>
                  <div className="qrTitle1"></div>
                  <div className="qrTitle2">
                    {i18n(lang).interner}
                    <Tooltip title={internerName}>
                      <span>{truncateWithEllipses(internerName, 100)}</span>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div className="downloadAsPDF">
              <PDFDownloadLink
                document={<MyDoc />}
                fileName={name + "-QRCode.pdf"}
              >
                {({ loading }) =>
                  loading
                    ? i18n(lang).loading_document + "..."
                    : i18n(lang).download_as_pdf
                }
              </PDFDownloadLink>
            </div>
          </div>
        </div>
      </Paper>

      <Button
        variant="contained"
        sx={{ textTransform: "uppercase", marginBottom: "24px" }}
        onClick={() => {
          editMode ? handleEditMachine() : handleAddMachine();
        }}
        disabled={
          constructionDate === "" ||
          ( new Date(constructionDate).getTime() >  new Date().getTime()) ||    // comparing unix timestamp
          (!editMode && area === "") ||
          loader ||
          (!editMode && brand === null)
        }
      >
        {" "}
        <Box sx={{ display: "flex" }}>
          {loader && (
            <CircularProgress
              sx={{ marginRight: "15px" }}
              className="EqLoader"
              size={24}
            />
          )}
        </Box>{" "}
        {loader
          ? i18n(lang).creating_equipment
          : editMode
            ? i18n(lang).save
            : i18n(lang).button_create_equipment}{" "}
      </Button>
    </>
  );
}

export default CreateEquipment;
